module.exports = __webpack_public_path__ + "static/media/logop7_nfund.d993cb5f.png";